import {Alert} from 'platform/components';
import {Show, useDevice, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface AggregateMotWarningsProps extends TestIdProps {
  canReadVehicle: boolean;
  isViewLoading: boolean;
  expiredCount: number;
  expiringCount: number;
  /** The overview reported no expired and no expiring car, so the warnings turn into one success. */
  isAllMotValid: boolean;
  onViewExpired: () => void;
  onViewExpiring: () => void;
}

export function AggregateMotWarnings(props: AggregateMotWarningsProps) {
  const device = useDevice();
  const hyperlinks = (onClick: () => void) =>
    props.canReadVehicle
      ? [
          {
            title: i18n.t('page.homepage.labels.view'),
            onClick,
            isDisabled: props.isViewLoading,
          },
        ]
      : undefined;

  return (
    <VStack spacing={4}>
      <Show when={props.isAllMotValid}>
        <Alert
          variant="success"
          type="inline"
          title={i18n.t('page.homepage.vehicleWarehouse.labels.allMotValid')}
          titleSize={device === 'mobile' ? 6 : 5}
          message={i18n.t('page.homepage.vehicleWarehouse.labels.allMotValidDescription')}
          messageSize={['xSmall', 'small']}
          data-testid={suffixTestId('motAllGoodAlert', props)}
        />
      </Show>
      <Show when={props.expiringCount > 0}>
        <Alert
          variant="warning"
          type="inline"
          title={i18n.t('page.homepage.vehicleWarehouse.labels.motExpiresIn30Days')}
          titleSize={device === 'mobile' ? 6 : 5}
          message={i18n.t('page.homepage.vehicleWarehouse.labels.carCount', {
            count: props.expiringCount,
          })}
          messageSize={['xSmall', 'small']}
          hyperlinks={hyperlinks(props.onViewExpiring)}
          data-testid={suffixTestId('motExpiresIn30DaysAlert', props)}
        />
      </Show>
      <Show when={props.expiredCount > 0}>
        <Alert
          variant="error"
          type="inline"
          title={i18n.t('page.homepage.vehicleWarehouse.labels.motExpired')}
          titleSize={device === 'mobile' ? 6 : 5}
          message={i18n.t('page.homepage.vehicleWarehouse.labels.carCount', {
            count: props.expiredCount,
          })}
          messageSize={['xSmall', 'small']}
          hyperlinks={hyperlinks(props.onViewExpired)}
          data-testid={suffixTestId('motExpiredAlert', props)}
        />
      </Show>
    </VStack>
  );
}
